var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPixBancoCentral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg859",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 500 177.8",
    style: {
      enableBackground: "new 0 0 500 177.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:none;stroke:#939598;stroke-width:2.9764;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.st1{fill:#32bcad}.st2{fill:#939598}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-535.594 -20.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2356",
    className: "st0",
    d: "M742 186.8v-102c0-18.8 15.2-34 34-34h30.1c18.7 0 33.8 15.2 33.8 33.9v21.7c0 18.8-15.2 34-34 34h-42.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2360",
    className: "st0",
    d: "M848.3 50.9h13.1c7.7 0 13.9 6.2 13.9 13.9V141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2364",
    className: "st1",
    d: "m872.5 39.1-5.9-5.9c-1.5-1.5-1.5-3.9 0-5.3l5.9-5.9c1.5-1.5 3.9-1.5 5.3 0l5.9 5.9c1.5 1.5 1.5 3.9 0 5.3l-5.9 5.9c-1.5 1.4-3.9 1.4-5.3 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2368",
    className: "st0",
    d: "M900.3 50.8h12.9c6.7 0 13 2.6 17.8 7.4l30.3 30.3c3.9 3.9 10.3 3.9 14.2 0l30.2-30.2c4.7-4.7 11.1-7.4 17.8-7.4h10.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2372",
    className: "st0",
    d: "M900.3 140.3h12.9c6.7 0 13-2.6 17.8-7.4l30.3-30.3c3.9-3.9 10.3-3.9 14.2 0l30.2 30.2c4.7 4.7 11.1 7.4 17.8 7.4h10.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2376",
    className: "st1",
    d: "M664.8 159.6c-6.5 0-12.6-2.5-17.2-7.1l-24.8-24.8c-1.7-1.7-4.8-1.7-6.5 0l-24.9 24.9c-4.6 4.6-10.7 7.1-17.2 7.1h-4.9l31.5 31.5c9.8 9.8 25.8 9.8 35.6 0l31.6-31.6h-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2380",
    className: "st1",
    d: "M574.1 71.8c6.5 0 12.6 2.5 17.2 7.1l24.9 24.9c1.8 1.8 4.7 1.8 6.5 0L647.6 79c4.6-4.6 10.7-7.1 17.2-7.1h3l-31.6-31.6c-9.8-9.8-25.8-9.8-35.6 0l-31.5 31.5h5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2384",
    className: "st1",
    d: "m693.9 98-19.1-19.1c-.4.2-.9.3-1.4.3h-8.7c-4.5 0-8.9 1.8-12 5L627.9 109c-2.3 2.3-5.4 3.5-8.4 3.5-3.1 0-6.1-1.2-8.4-3.5l-24.9-24.9c-3.2-3.2-7.6-5-12-5h-10.7c-.5 0-.9-.1-1.3-.3L543 98c-9.8 9.8-9.8 25.8 0 35.6l19.1 19.1c.4-.2.8-.3 1.3-.3h10.7c4.5 0 8.9-1.8 12-5l24.9-24.9c4.5-4.5 12.4-4.5 16.9 0l24.8 24.8c3.2 3.2 7.6 5 12 5h8.7c.5 0 .9.1 1.4.3l19.1-19.1c9.8-9.8 9.8-25.7 0-35.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2388",
    className: "st2",
    d: "M767.8 178.1c-1.4 0-3 .3-4.7.7v6.2c1.1.4 2.4.6 3.6.6 3.1 0 4.6-1.1 4.6-3.8.1-2.5-1.1-3.7-3.5-3.7m-5.7 11.6v-12.3h.9l.1.5c1.4-.3 3.4-.8 4.9-.8 1.2 0 2.3.2 3.2.9 1.1.9 1.4 2.3 1.4 3.8 0 1.6-.5 3.1-2 4-1 .6-2.4.8-3.6.8-1.3 0-2.5-.2-3.7-.6v3.6h-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2392",
    className: "st2",
    d: "M780.4 178.1c-3.1 0-4.5 1-4.5 3.7s1.4 3.8 4.5 3.8 4.5-1 4.5-3.7c-.1-2.6-1.4-3.8-4.5-3.8m4 7.6c-1 .7-2.4 1-4 1s-3-.2-4-1c-1.1-.8-1.6-2.1-1.6-3.8 0-1.6.5-3 1.6-3.8 1-.7 2.4-1 4-1s3 .2 4 1c1.2.8 1.6 2.2 1.6 3.8 0 1.6-.5 3-1.6 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2396",
    className: "st2",
    d: "m799.1 186.4-3.5-7.5h-.1l-3.4 7.5h-.9l-3.7-9h1.2l3.1 7.5h.1l3.3-7.5h1l3.4 7.5h.1l3-7.5h1.1l-3.7 9h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2400",
    className: "st2",
    d: "M810.5 178.1c-2.9 0-3.9 1.3-4 3.1h8.1c-.2-2-1.2-3.1-4.1-3.1m-.1 8.5c-1.7 0-2.8-.2-3.7-1-1.1-.9-1.4-2.2-1.4-3.7 0-1.4.5-3 1.7-3.8 1-.7 2.2-.9 3.5-.9 1.2 0 2.5.1 3.6.9 1.3.9 1.6 2.4 1.6 4.1h-9.2c0 1.9.6 3.5 4.1 3.5 1.7 0 3.2-.3 4.6-.5v.9c-1.5.2-3.2.5-4.8.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2404",
    className: "st2",
    d: "M818.6 186.4v-9h.9l.1.5c1.9-.5 2.8-.8 4.5-.8h.1v1h-.3c-1.4 0-2.3.2-4.2.7v7.5l-1.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2408",
    className: "st2",
    d: "M830.3 178.1c-2.9 0-3.9 1.3-4 3.1h8.1c-.2-2-1.2-3.1-4.1-3.1m-.1 8.5c-1.7 0-2.8-.2-3.7-1-1.1-.9-1.4-2.2-1.4-3.7 0-1.4.5-3 1.7-3.8 1-.7 2.2-.9 3.5-.9 1.2 0 2.5.1 3.6.9 1.3.9 1.6 2.4 1.6 4.1h-9.2c0 1.9.6 3.5 4.1 3.5 1.7 0 3.2-.3 4.6-.5v.9c-1.5.2-3.2.5-4.8.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2412",
    className: "st2",
    d: "M846.9 178.7c-1.1-.4-2.4-.6-3.6-.6-3.1 0-4.6 1.1-4.6 3.8 0 2.6 1.2 3.7 3.6 3.7 1.4 0 3-.3 4.7-.7v-6.2zm.2 7.7-.1-.5c-1.4.3-3.4.8-4.9.8-1.2 0-2.3-.2-3.2-.9-1.1-.9-1.4-2.3-1.4-3.8 0-1.6.5-3.1 2-3.9 1-.6 2.4-.8 3.6-.8 1.2 0 2.5.2 3.7.6v-4.1h1.1v12.8l-.8-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2416",
    className: "st2",
    d: "M863.4 178.1c-1.4 0-3 .3-4.7.7v6.2c1.1.4 2.4.6 3.6.6 3.1 0 4.6-1.1 4.6-3.8 0-2.5-1.2-3.7-3.5-3.7m2.7 7.7c-1 .6-2.4.8-3.6.8-1.3 0-2.7-.2-4-.7l-.1.4h-.7v-12.8h1.1v4.3c1.4-.3 3.4-.7 4.8-.7 1.2 0 2.3.2 3.2.9 1.1.9 1.4 2.3 1.4 3.8-.1 1.7-.7 3.2-2.1 4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2420",
    className: "st2",
    d: "M869.4 189.8v-1c.5.1 1 .1 1.3.1 1.3 0 2.1-.4 2.8-1.9l.3-.7-4.7-9h1.2l4 7.8h.1l3.8-7.8h1.2l-5.1 10.1c-.9 1.8-1.9 2.4-3.8 2.4-.2.1-.6.1-1.1 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2424",
    className: "st2",
    d: "M894 181.2h-3.5v3.2h3.5c2.4 0 3.3-.3 3.3-1.6.1-1.4-1.2-1.6-3.3-1.6m-.6-5.1h-2.8v3.2h2.9c2.4 0 3.3-.3 3.3-1.6-.1-1.4-1.3-1.6-3.4-1.6m5.4 9.4c-1.3.8-2.8.9-5.7.9h-5.3v-12.2h5.2c2.4 0 3.9 0 5.2.8.9.5 1.2 1.4 1.2 2.4 0 1.3-.5 2.1-1.9 2.7v.1c1.6.4 2.6 1.2 2.6 2.9 0 1.1-.4 1.9-1.3 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2428",
    className: "st2",
    d: "M910.8 182.6c-1.1-.1-2.1-.1-3.2-.1-1.8 0-2.5.4-2.5 1.2 0 .8.5 1.2 1.9 1.2 1.2 0 2.6-.3 3.8-.5v-1.8zm.5 3.8-.1-.5c-1.5.4-3.3.8-4.9.8-1 0-2-.1-2.7-.7-.7-.5-1-1.3-1-2.2 0-1 .4-2 1.5-2.4.9-.4 2.2-.5 3.4-.5.9 0 2.2.1 3.3.1v-.2c0-1.4-.9-1.9-3.5-1.9-1 0-2.2.1-3.3.2v-1.8c1.3-.1 2.7-.2 3.9-.2 1.6 0 3.2.1 4.2.8 1 .7 1.2 1.7 1.2 3.1v5.3l-2 .1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2432",
    className: "st2",
    d: "M925 186.4v-5c0-1.6-.8-2.2-2.3-2.2-1.1 0-2.5.3-3.7.6v6.6h-2.5v-9h2l.1.6c1.6-.4 3.3-.8 4.8-.8 1.1 0 2.2.2 3.1.9.7.6 1 1.5 1 2.8v5.5H925z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2436",
    className: "st2",
    d: "M934.6 186.6c-1.2 0-2.4-.2-3.3-.9-1.1-.9-1.4-2.3-1.4-3.8 0-1.4.5-3 1.8-3.8 1.1-.7 2.5-.9 4-.9 1 0 2 .1 3.2.2v1.9c-.9-.1-2-.2-2.9-.2-2.4 0-3.5.7-3.5 2.8 0 1.9.8 2.8 2.8 2.8 1.1 0 2.5-.2 3.8-.5v1.9c-1.5.2-3.1.5-4.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2440",
    className: "st2",
    d: "M946.4 179c-2.4 0-3.4.7-3.4 2.8 0 2 1 2.9 3.4 2.9s3.4-.7 3.4-2.8c0-2-1-2.9-3.4-2.9m4.3 6.7c-1.1.7-2.5.9-4.3.9-1.8 0-3.2-.2-4.3-.9-1.2-.8-1.7-2.2-1.7-3.8 0-1.6.4-3 1.7-3.8 1.1-.7 2.5-.9 4.3-.9 1.8 0 3.2.2 4.3.9 1.2.8 1.7 2.2 1.7 3.8 0 1.6-.5 3-1.7 3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2444",
    className: "st2",
    d: "M966.9 186.6c-1.5 0-3.2-.2-4.4-1.3-1.5-1.2-1.9-3.1-1.9-5.1 0-1.8.6-3.9 2.5-5.2 1.5-1 3.3-1.2 5.2-1.2 1.4 0 2.7.1 4.3.2v2.2c-1.3-.1-2.9-.2-4.1-.2-3.5 0-4.9 1.3-4.9 4.1 0 2.9 1.4 4.2 3.9 4.2 1.7 0 3.5-.3 5.4-.7v2.2c-2 .4-4 .8-6 .8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2448",
    className: "st2",
    d: "M980.1 178.7c-2.1 0-2.9.7-3 2.1h6.1c-.1-1.4-1-2.1-3.1-2.1m-.4 7.9c-1.5 0-2.8-.2-3.8-1-1.1-.9-1.4-2.2-1.4-3.8 0-1.4.4-2.9 1.7-3.8 1.1-.8 2.5-.9 3.9-.9 1.3 0 2.8.1 3.9.9 1.4 1 1.6 2.6 1.6 4.4h-8.5c.1 1.4.8 2.3 3.3 2.3 1.6 0 3.3-.2 4.8-.5v1.8c-1.8.3-3.7.6-5.5.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2452",
    className: "st2",
    d: "M996.8 186.4v-5c0-1.6-.8-2.2-2.3-2.2-1.1 0-2.5.3-3.7.6v6.6h-2.5v-9h2l.1.6c1.6-.4 3.3-.8 4.8-.8 1.1 0 2.2.2 3.1.9.7.6 1 1.5 1 2.8v5.5h-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2456",
    className: "st2",
    d: "M1006.4 186.6c-1.2 0-2.3-.3-2.9-1.3-.4-.6-.7-1.5-.7-2.7v-3.4h-1.8v-1.9h1.8l.3-2.7h2.2v2.7h3.5v1.9h-3.5v2.9c0 .7.1 1.3.2 1.7.3.6.9.8 1.6.8.6 0 1.3-.1 1.8-.2v1.8c-.7.3-1.7.4-2.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2460",
    className: "st2",
    d: "M1011.3 186.4v-9h2l.1.6c1.7-.5 2.9-.8 4.5-.8h.3v2.1h-.9c-1.2 0-2.2.1-3.5.5v6.6h-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2464",
    className: "st2",
    d: "M1027.3 182.6c-1.1-.1-2.1-.1-3.2-.1-1.8 0-2.5.4-2.5 1.2 0 .8.5 1.2 1.9 1.2 1.2 0 2.6-.3 3.8-.5v-1.8zm.6 3.8-.1-.5c-1.5.4-3.3.8-4.9.8-1 0-2-.1-2.7-.7-.7-.5-1-1.3-1-2.2 0-1 .4-2 1.5-2.4.9-.4 2.2-.5 3.4-.5.9 0 2.2.1 3.3.1v-.2c0-1.4-.9-1.9-3.5-1.9-1 0-2.2.1-3.3.2v-1.8c1.3-.1 2.7-.2 3.9-.2 1.6 0 3.2.1 4.2.8 1 .7 1.2 1.7 1.2 3.1v5.3l-2 .1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2466",
    className: "st2",
    d: "M1033.1 173.6h2.5v12.8h-2.5v-12.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixBancoCentral);
export default __webpack_public_path__ + "static/media/pix-banco-central.7d90b8511df7f1fdffe6c6797c30b48f.svg";
export { ForwardRef as ReactComponent };